import React, { useState } from "react";
import { loginUser } from "../services/api";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please enter your email and password.");
      setSuccess("");
      return;
    }
    setError("");
    setSuccess("");
    try {
      const res = await loginUser(email, password);
      if (res.token) {
        localStorage.setItem("token", res.token);
        // Log and verify token
        try {
          const decoded = jwtDecode(res.token);
          console.log("Decoded JWT after login:", decoded);
        } catch (e) {
          console.warn("JWT decode error", e);
        }
        setSuccess("Login successful! Redirecting...");
        setEmail("");
        setPassword("");
        setTimeout(() => {
          navigate("/profile"); // Adjust as needed
        }, 1200);
      } else {
        setError(res.error || "Login failed");
      }
    } catch (err) {
      setError(err.message || "Could not connect to backend.");
    }
  };

  return (
    <div style={{
      maxWidth: "350px",
      margin: "60px auto",
      padding: "30px",
      background: "#23233a",
      borderRadius: "13px"
    }}>
      <h2 style={{ color: "#a261e7" }}>Log In</h2>
      {error && <div style={{ color: "#ff5860", marginBottom: "8px" }}>{error}</div>}
      {success && <div style={{ color: "#6dd06d", marginBottom: "8px" }}>{success}</div>}
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "11px", borderRadius: "8px", padding: "8px" }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "18px", borderRadius: "8px", padding: "8px" }}
        />
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "11px",
            background: "#a261e7",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "7px",
            border: "none"
          }}
        >
          Log In
        </button>
      </form>
    </div>
  );
};

export default Login;
